import Swiper from 'swiper';
import { Pagination, Autoplay, Controller } from 'swiper';
import { getDisplayMode } from './libs';

const setHeroBannerSlider = () => {
  const bannerSlider = document.querySelector(".js-hero-slider");
  const slideLength = bannerSlider?.querySelectorAll(".swiper-slide").length;
  let first = false;
  let windowWidth = bannerSlider?.clientWidth;
  let slideSize = 0;
  let slideSpace = 0;
  if (getDisplayMode() == 1) {
    slideSize = 710;
    slideSpace = 32;
  } else {
    slideSize = windowWidth - 30;
    slideSpace = 30;
  }
  let viewSlideLength = Math.floor(windowWidth / (slideSize + slideSpace));


  if (slideLength > viewSlideLength) {
    var swiper = new Swiper(bannerSlider, {
      modules: [Pagination, Autoplay],
      autoplay: {
        disableOnInteraction: false,
      },
      speed: 500,
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: slideSpace,
      centeredSlides: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      on: {
        slideChange: function () {
          if (!first) {
            this.params.autoplay.delay = 3500;
          } else {
            this.params.autoplay.delay = 3000;
          }
        },
        afterInit: function () {
          first = true;
        },
      }
    });
  } else {
    bannerSlider?.classList.add('slide-none');
  }
  bannerSlider?.classList.add('is-init')
}

export default setHeroBannerSlider;